import styled from 'styled-components';

export const DashboardContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  min-height: calc(100vh - 120px);
  background-color: #f8f9fa;

  h1 {
    color: #2c3e50;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
    text-align: center;
    border-bottom: 3px solid #3498db;
    padding-bottom: 1rem;
  }

  h2 {
    color: #34495e;
    font-size: 1.8rem;
    font-weight: 600;
    margin: 2rem 0 1rem 0;
    padding-left: 1rem;
    border-left: 4px solid #e74c3c;
  }

  p {
    color: #5a6c7d;
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    text-align: center;

    &:first-of-type {
      font-weight: 600;
      color: #2c3e50;
    }
  }
`;

export const WelcomeSection = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 2rem;
  border-radius: 12px;
  margin-bottom: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  position: relative;

  h1 {
    color: white;
    border-bottom: 3px solid rgba(255, 255, 255, 0.3);
    margin-bottom: 1rem;
  }

  p {
    color: rgba(255, 255, 255, 0.9);
    text-align: left;
    margin-bottom: 0.5rem;
    
    &:first-of-type {
      color: white;
      font-size: 1.2rem;
    }
  }
`;

export const Section = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e9ecef;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  }
`;

export const FormContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px dashed #dee2e6;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const Input = styled.input`
  flex: 1;
  min-width: 250px;
  padding: 0.75rem 1rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
  outline: none;

  &:focus {
    border-color: #3498db;
    box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
  }

  &::placeholder {
    color: #adb5bd;
  }

  @media (max-width: 768px) {
    min-width: 100%;
  }
`;

export const Button = styled.button`
  padding: 0.75rem 1.5rem;
  background: ${props => {
    switch(props.variant) {
      case 'danger': return 'linear-gradient(135deg, #e74c3c, #c0392b)';
      case 'success': return 'linear-gradient(135deg, #27ae60, #229954)';
      case 'warning': return 'linear-gradient(135deg, #f39c12, #e67e22)';
      default: return 'linear-gradient(135deg, #3498db, #2980b9)';
    }
  }};
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 1rem;
  }
`;

export const ItemList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const ListItem = styled.li`
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1rem 1.5rem;
  margin-bottom: 0.75rem;
  transition: all 0.3s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(135deg, #3498db, #2980b9);
  }

  &:hover {
    background: #e3f2fd;
    border-color: #3498db;
    transform: translateX(5px);
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ItemText = styled.span`
  color: #2c3e50;
  font-size: 1.1rem;
  font-weight: 500;
`;

export const ItemMeta = styled.span`
  color: #6c757d;
  font-size: 0.9rem;
  font-style: italic;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 3rem 2rem;
  color: #6c757d;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px dashed #dee2e6;

  h3 {
    color: #adb5bd;
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1rem;
    line-height: 1.6;
  }
`;

export const PermissionBadge = styled.span`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background: ${props => {
    if (props.role === 'site_admin') return 'linear-gradient(135deg, #e74c3c, #c0392b)';
    if (props.role === 'teacher') return 'linear-gradient(135deg, #f39c12, #e67e22)';
    return 'linear-gradient(135deg, #95a5a6, #7f8c8d)';
  }};
  color: white;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  margin: 0 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;

  &:after {
    content: '';
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @keyframes slideInFromRight {
    0% {
      transform: translateX(100%);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

export const ErrorMessage = styled.div`
  background: #f8d7da;
  color: #721c24;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  border: 1px solid #f5c6cb;
  margin-bottom: 1rem;
  font-weight: 500;
`;

export const SuccessMessage = styled.div`
  background: #d4edda;
  color: #155724;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  border: 1px solid #c3e6cb;
  margin-bottom: 1rem;
  font-weight: 500;
`;

export const UserProfilePanel = styled.div`
  position: absolute;
  top: 2rem;
  right: 2rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-1px);
  }

  @media (max-width: 768px) {
    position: static;
    margin-top: 1rem;
    justify-content: center;
  }
`;

export const UserName = styled.span`
  font-weight: 600;
  font-size: 1rem;
  color: white;
  min-width: 80px;
  text-align: right;

  @media (max-width: 768px) {
    text-align: center;
    min-width: auto;
  }
`;

export const EditButton = styled.button`
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  font-size: 0.9rem;

  &:hover {
    color: white;
    background: rgba(255, 255, 255, 0.1);
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const NameEditModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2001;
  backdrop-filter: blur(5px);
`;

export const NameEditForm = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 400px;
  animation: slideUp 0.3s ease-out;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  h3 {
    margin: 0 0 1.5rem 0;
    color: #2c3e50;
    font-size: 1.3rem;
    text-align: center;
  }
`;

export const NameInput = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 1rem;
  margin-bottom: 1.5rem;
  transition: all 0.3s ease;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: #3498db;
    box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
  }

  &::placeholder {
    color: #adb5bd;
  }
`;

export const ModalButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

export const ModalButton = styled.button`
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;
  min-width: 80px;

  ${props => props.variant === 'cancel' ? `
    background: #6c757d;
    color: white;
    
    &:hover {
      background: #5a6268;
      transform: translateY(-1px);
    }
  ` : `
    background: linear-gradient(135deg, #3498db, #2980b9);
    color: white;
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 15px rgba(52, 152, 219, 0.3);
    }
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }
  `}

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;